import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import {DemoService} from './../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {Client} from './../../domain/client'
import {Job} from './../../domain/job'
import {Subject} from './../../domain/subject'
import {Job_Type} from './../../domain/job_type'
import { GlobalFunctionsService } from './../../services/global-functions.service';


@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.css',
],
providers: [DatePipe]
})
export class JobsComponent implements OnInit {


  clients: Client[];
  jobs: Job[];
  subjects: Subject[];
  job_types: Job_Type[];

  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: Object;
  JobStep2ID: any;
  job_type:any;
  job_type_name: any;
  newDate: any;
  date: any;

  private gridApi;
  private gridColumnApi;

  private columnDefs;
  private defaultColDef;
 

  
rowData: any;
carMappings: any;
  name: any;
  sessionUsername: any;
  all_router_details: string;
  current_base_route: string;



  constructor( private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
     vcr: ViewContainerRef, private router: Router, 
      public datepipe: DatePipe, public dateFormatter: DatePipe, public gfunc: GlobalFunctionsService ) { 


      this.nav = document.querySelector('nav.navbar');
      // this.toastr.setRootViewContainerRef(vcr);

    // login vars
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));







    this.columnDefs = [
      {headerName: 'Client', field: 'client_id', sortable: 'true', filter: "agTextColumnFilter", resizable: 'true',
      // refData: carMappings, // just required to specify refData!
     valueFormatter: function (params) {
        // convert code to value
        return lookupValue(carMappings, params.value);
    },
    valueParser: function(params) {
      return lookupKey(carMappings, params.newValue);
    }
    
    },

    
      {headerName: 'Client Reference', field: '', sortable: true, filter: "agNumberColumnFilter",  resizable: 'true'},
      {headerName: 'Status', field: 'status', sortable: true, filter: "agNumberColumnFilter",  resizable: true},
      {headerName: 'File Number', field: 'job_number', sortable: true, filter: "agNumberColumnFilter"},
      {headerName: 'File Reference', field: 'file_number', sortable: true, filter: "agNumberColumnFilter"},
      {headerName: 'File Type', field: 'job_type_id', sortable: true, filter: "agNumberColumnFilter"},
      {headerName: 'Subject Name', field: 'first_name', sortable: true, filter: "agTextColumnFilter",
      valueGetter: 'data.first_name + " " + data.surname',
      valueSetter:
        'var nameSplit = newValue.split(" ");' +
        "var newfirst_name = nameSplit[0];" +
        "var newsurname = nameSplit[1];" +
        "if (data.first_name !== newsurname || data.surname !== newsurname) {" +
        "  data.first_name = newfirst_name;" +
        "  data.surname = newsurname;" +
        "  return true;" +
        "} else {" +
        "  return false;" +
        "}"
    
    
    },
      {headerName: 'Next Date', field: 'next_date', sortable: true, filter: "agDateColumnFilter", valueFormatter: this.dateFormatter223
    
    },
      {headerName: 'Final Date', field: 'final_date', sortable: true, filter: "agNumberColumnFilter",
      valueFormatter: function (params) {
        // convert code to value
       // return dateFormatter22(params.value);
    },
    },
      {headerName: 'Hearing Date', field: 'hearing_date', sortable: true, filter: "agNumberColumnFilter",
      valueFormatter: function(params) {
       // return params.node.rowIndex;
       return params.data.hearing_date;
         // this.dateFormatter.transform(params.hearing_date, 'shortDate');
       
      }
    },
      {headerName: 'Judgement Date', field: 'judgement_date', sortable: true, filter: "agNumberColumnFilter"},
      {headerName: 'Agent(s)', field: 'agent_id', sortable: true, filter: "agNumberColumnFilter", unSortIcon: true, },
      {headerName: 'Closed', field: '', sortable: true, filter: "agTextColumnFilter"},
      {headerName: 'Invoiced', field: '', sortable: true, filter: "agTextColumnFilter"},
  ];
  this.defaultColDef = { resizable: true };



 /*
  fetch(this.gfunc.apiURL + '/api/client/mappings/all')
  .then(result => result.json())
  .then(carMappings => this.carMappings = carMappings);
  */

  var carMappings = {
    "1": "Nijo Dream Pty Ltd",
    frd: "Ford",
    prs: "Porsche",
    nss: "Nissan"
  };

  


  function extractValues(mappings) {
    return Object.keys(mappings);
  }
  function lookupValue(mappings, key) {
    return mappings[key];
  }
  function lookupKey(mappings, name) {
    for (var key in mappings) {
      if (mappings.hasOwnProperty(key)) {
        if (name === mappings[key]) {
          return key;
        }
      }
    }
  }


  function dateFormatter22(params) {
   // return "\xA3" + params.value;
    return this.dateFormatter.transform(params.value, 'dd-MM-yy');
    // let newDate = params.value;
    // this.newDate =  this.datepipe.transform(new Date(), 'dd-MM-yy');
   // return this.newDate;
   // this.formatTheDate(params.value)
   
   }
  
  

     }

  ngOnInit() {
   // this.clientService.getClients().then(clients => this.clients = clients);
   // this.clientService.getJobsAll().then(jobs => this.jobs = jobs);

  //  this.clientService.getSubjectsAll().then(subjects => this.subjects = subjects);
    // this.getJobType(1);

  // this.rowData = this.http.get(this.gfunc.apiURL + '/api/job/table/all'); 

   fetch(this.gfunc.apiURL + '/api/job/table/all')
   .then(result => result.json())
   .then(rowData => this.rowData = rowData);
console.log(this.rowData);


fetch(this.gfunc.apiURL + '/api/client/mappings/all')
.then(result => result.json())
.then(carMappings => this.carMappings = carMappings);

   // this.rowData = this.getJobType(1);

    // this.rowData = this.clientService.getSubjectsAll();

   // this.date = this.datepipe.transform(new Date(), 'dd-MM-yyyy');
   // console.log(this.date);




  }


onDoubleClickRow(event){

}



returnClient ( params ){

  this._demoService.getClientMappingID(params.value).subscribe(
    data => { 
     // this.job_type = data;
    // this.job_type = data;
// console.log(this.job_type)
let res = data[0];
this.name = res['name']; 
console.log(this.name)
return this.name;
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );


}

dateFormatter223(params) {
 return "\xA3" + params.value;
 //return this.dateFormatter.transform(params.value, 'dd-MM-yy');
 // let newDate = params.value;
 // this.newDate =  this.datepipe.transform(new Date(), 'dd-MM-yy');
// return this.newDate;
// this.formatTheDate(params.value)

}

formatTheDate(date)
{
  return this.dateFormatter.transform(date, 'dd-MM-yy');
}


formatNumber(number) {
  return Math.floor(number)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}



selectCar(job: Job) {
  this.router.navigate(['/admin/jobs/create-job-3/' + job.job_id + '']);

}



// Get the name of job type from the ID
getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => { 
      // this.job_type = data;
     // this.job_type = data;
// console.log(this.job_type)
let res = data[0];
this.job_type_name = res['job_type_name']; 
console.log(this.job_type_name)
return this.job_type_name;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
   
 }



 getJobTypeName(job_type_id){

//  this.clientService.getJobType(job_type_id).then(job_types => this.job_types = job_types);
 // return this.job_type.job_type_name;

 
  
}








}
